enum NumericViewMode {
    Proportion = 1,
    Percent = 2,
}

export default NumericViewMode;
